import { useCallback } from 'react';
import * as XLSX from 'xlsx-js-style';

type typeWidth = { i: number; width: number; }

type typeStyles = {
    widths: typeWidth[];
}

const s2ab = (s: string) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
}

export const useExcelMaker = () => {
    return useCallback((headers: string[], data: (string | number)[][], styles: typeStyles, filename: string) => {
        if (!data.length) return;
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
        headers.forEach((_, i) => {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: i });
            const cell = worksheet[cellAddress];
            if (cell) {
                cell.s = {
                    font: { bold: true },
                    alignment: { horizontal: 'center' }
                };
            }
        });
        worksheet['!cols'] = headers.map((_, i) => ({ wch: styles.widths.find(w => w.i === i)?.width ?? 10 }));
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos');
        const binary = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
        const blob = new Blob([s2ab(binary)], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }, []);
}
